import { render, staticRenderFns } from "./CollectionType.vue?vue&type=template&id=4cef06d6&scoped=true&"
import script from "./CollectionType.vue?vue&type=script&lang=js&"
export * from "./CollectionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef06d6",
  null
  
)

export default component.exports